module.exports = __webpack_public_path__ + "static/Kommisionierer-fe7e75e3b093c7c6a3a5825aad5f4a8f.jpg";